import 'easytimer.js';

const logoutTimer = {

	init() {

		// Init logout Timer
		timer = new timer();
		timer.start({
			countdown: true,
			startValues: {
				seconds: 300
			}
		});

		timer.addEventListener('secondsUpdated', function() {
			$('#actionCountdown').html(timer.getTimeValues().toString(['minutes', 'seconds']));
		});

	}

};

export default logoutTimer;

